// downloads a file from url with a name
export const downloadFileFromURL = (url: string, name: string = 'Download') => {
  fetch(url)
    .then((resp) => resp.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    })
    .catch(() => {
      console.error('Failed to donwload file.', { url, name });
      alert('Failed to download file.');
    });
};
